import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EligibilityVerificationType } from '@ktypes/enums';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-screen-eligibility',
  templateUrl: './screen-eligibility.component.html',
})
export class ScreenEligibilityComponent implements OnInit, OnDestroy {
  eligibilityType: EligibilityVerificationType;
  eligibilityVerificationType = EligibilityVerificationType;

  private _destroy$ = new Subject<void>();

  constructor(private _activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this._activatedRoute.params.pipe(takeUntil(this._destroy$)).subscribe((params) => {
      this.eligibilityType = params['eligibilityType'] as EligibilityVerificationType;
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
